export const config = [
  {
    texts: {
      header: "CS_SEARCH_RESULTS",
      actionButtonLabel: "CS_VIEW_DETAILS",
    },
    labels: [
      {
        label: "UC_AMOUNT_DUE_LABEL",
        key: "total_due",
        noteStyle: {
          fontSize: "24px",
          fontWeight: "bold",
        },
        notePrefix: "₹ ",
      },
      {
        label: "UC_CHALLAN_NO",
        key: "ChannelNo",
      },
      {
        label: "UC_SERVICE_CATEGORY_LABEL",
        key: "ServiceCategory",
      },
      {
        label: "UC_OWNER_NAME_LABEL",
        key: "OwnerName",
      },
      {
        label: "UC_DUE_DATE",
        key: "bil_due__date",
      },
    ],
  },
];
